<template>
  <v-app>
    <page-header v-if="$store.state.token" />
    <main>
      <router-view />
      <accept-terms />
    </main>
  </v-app>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import AcceptTerms from '@/components/AcceptTerms.vue'

export default {
  name: 'app',
  mounted () {
    window.vm = this
  },
  components: {
    PageHeader,
    AcceptTerms
  }
}
</script>

<style>
a.big-link {
  text-decoration: none;
  display: inline-block;
  padding: 8px 14px;
}

a.big-link:hover {
  text-decoration: underline;
  background: rgba(50, 50, 127, 0.08);
}

th.has-big-links {
  padding-left: 38px !important;
}

.big-non-link {
  text-decoration: none;
  display: inline-block;
  padding-left: 22px;
}

.big-non-link:hover {
  background: rgba(50, 50, 127, 0.08);
}

th.has-big-links {
  padding-left: 38px !important;
}

.has-big-non-links {
  padding-left: 38px !important;
}

@media screen and (max-width: 750px) {
  th.has-big-links {
    padding-left: 26px !important;
  }
  a.big-link {
    padding: 4px 4px;
  }
  .big-non-link {
    padding: 4px 4px;
  }
}
.required label:after {
  color: red;
  content: ' *';
}

input[readonly] {
  background: #f8f8f8;
}
</style>
